/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { Row, Col, Card, CardBody, Table, Tooltip } from 'reactstrap';

import { RiErrorWarningLine } from 'react-icons/ri';

import ParticipanteIcon from '~/assets/img/participante.svg';
import ParticipanteIconPreenchido from '~/assets/img/participante_preenchido.svg';
import { StatusVenda } from '~/components/Status';
import { Cartoes } from '~/components/Cartoes';
import { LoaderMini } from '~/components/Loaders';
import { Text } from '~/components/Text';
import { color } from '~/assets/styles/colors';
import { symbolPriceFormatter } from '~/helpers/price';


import { TheadStyled, TrStyled } from '../styles';


export function RecebimentosSplit({ dadosSplit, recebimentos, projetos }) {
	const { user } = useSelector((state) => state.auth);
	const [tooltipDescricao, setTooltipDescricao] = useState(null);
	const toggleTooltip = (itemId) => {
		setTooltipDescricao(tooltipDescricao === itemId ? null : itemId);
	};

	const listTooltipExceptions  = ['Não encontrado no BI']

	// function retornaModalidade(cell, row) {
	// 	if (row.parcelas > 1) {
	// 		return `Parcelado em ${row.parcelas}x`;
	// 	}
	// 	if (cell === 'crédito à vista') {
	// 		return `Crédito à vista`;
	// 	}
	// 	if (cell === 'débito') {
	// 		return `Débito`;
	// 	}
	// 	return cell;
	// }

	function retornaTipoCupom(tipo) {
		if (tipo === null) {
			return `-`;
		}
		if (tipo === 0) {
			return `QD`;
		}
		if (tipo === 1) {
			return `Loja`;
		}
		return tipo;
	}

	return (
		<Table id="test-table-xls-button" responsive className="notranslate">
			<TheadStyled>
				<TrStyled>
					<th>
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
							}}>
							{user.dados.cargo.toLowerCase() === 'industria' ? 'Distribuidores' : 'Revenda'}
						</div>
					</th>
					<th>
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
							}}>
							Dt Receb.
						</div>
					</th>
					<th>
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
							}}>
							Dt Venda
						</div>
					</th>
					<th>
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
							}}>
							Modalidade
						</div>
					</th>
					{user?.dados?.permissoes?.view_pgm === false &&
						<th>
							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
								}}>
								Bandeira
							</div>
						</th>
					}

					{!dadosSplit.parent && (
						<>
							{/* <th>
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
									}}>
									{user?.dados?.permissoes?.view_pgm ? 'Revenda' : 'Titular'}
								</div>
							</th> */}
							<th>
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
									}}>
									Split (%)
								</div>
							</th>
						</>
					)}
					<th>
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
							}}>
							{user?.dados?.permissoes?.view_pgm ? 'Transação' : 'Val Venda'}
						</div>
					</th>
					<th>
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
							}}>
							Bruto
						</div>
					</th>
					{user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' || user.dados.cargo.toLowerCase() === '' || user.dados.permissoes.view_labels_pgm_triplo ? <></> :
						<th>
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
								}}>
								<text>Descontos</text>
								<text style={{ marginRight: '10%' }}>(%)</text>
							</div>
						</th>
					}
					<th>
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
							}}>
							Líquido
						</div>
					</th>
					{projetos.includes(user.dados.tipo_projeto) &&
						<th>
							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
								}}>
								Destino Cred.
							</div>
						</th>
					}
					<th>
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
							}}>
							Status
						</div>
					</th>
				</TrStyled>
			</TheadStyled>
			<tbody>
				{recebimentos.lista.map((item, index) => (
					<tr key={`${item.autorizacao}-${index}`}>
						<td>
							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
								}}>
								{user.dados.cargo.toLowerCase() === 'industria' 
								? 
									`${item.distribuidor_nome ? item.distribuidor_nome: ''}`
								: 
									`${item.split_cliente ? item.split_cliente: ''}${item.split_cliente && item.split_cliente_nome? ' - ': ''} ${item.split_cliente_nome ? item.split_cliente_nome : ''}`
								}
							</div>
						</td>
						<td>
							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
								}}>
								{item.data_pagamento !== null
									? moment(item.data_pagamento, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('DD/MM/YYYY')
									: moment(item.data_agendado, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('DD/MM/YYYY')}
							</div>
						</td>
						<td>
							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
								}}>
								{item.data_transacao ? moment(item.data_transacao, ['DD/MM/YYYY', 'YYYY-MM-DD']).format('DD/MM/YYYY')
									: '-'}
							</div>
						</td>
						<td>
							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
								}}>
								{item.modalidade.toLowerCase() === 'crédito parcelado' || item.modalidade.toLowerCase() === 'credito parcelado'
									? `Parcelado em ${item.qtd_parcelas}x`
									: item.modalidade.toLowerCase() === 'crédito à vista' || item.modalidade.toLowerCase() === 'credito a vista'
										? `Crédito à Vista`
										: item.modalidade}
								{
									(item.descricao && !listTooltipExceptions.includes(item.descricao)) && (
										<>
											<p id={`Tooltip-${item.autorizacao ? item.autorizacao : index}`} style={{marginTop: "-1px",paddingLeft: "10px", color: color.red}}>
												<RiErrorWarningLine />
											</p>
											{/* <p id={`Tooltip-${item.autorizacao ? item.autorizacao : index}`} style={{paddingLeft: "10px"}}>
												<AnnouncementTwoToneIcon sx={{ color: color.redDark }} />
											</p> */}
											<Tooltip
												placement="top"
												isOpen={tooltipDescricao === (item.autorizacao ? item.autorizacao : index)}
												target={`Tooltip-${item.autorizacao ? item.autorizacao : index}`}
												toggle={() =>  toggleTooltip(item.autorizacao ? item.autorizacao : index)}
											>
												{`${item.descricao}`}
											</Tooltip>
										</>
										)
								}
							</div>
						</td>
						{user?.dados?.permissoes?.view_pgm === false &&
							<td>
								{item.bandeira &&
									<div
										style={{
											display: 'flex',
											justifyContent: 'center',
										}}>
										<Cartoes cartao={item.bandeira} />
									</div>
								}
							</td>
						}
						{!dadosSplit.parent && (
							<>
								{item.porcentagem_projeto ? (
									<td>
										<div
											style={{
												display: 'flex',
												justifyContent: 'center',
											}}>
											{`${item.porcentagem_projeto}`}
										</div>
									</td>
								) : (
									<td>
										<div
											style={{
												display: 'flex',
												justifyContent: 'center',
											}}>
											Não
										</div>
									</td>
								)}
							</>
						)}
						<td>
							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
								}}>
								{symbolPriceFormatter(item.valor_transacao)}
							</div>
						</td>
						<td>
							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
								}}>
								{symbolPriceFormatter(item.valor_bruto)}
							</div>
						</td>
						{user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' || user.dados.cargo.toLowerCase() === '' || user.dados.permissoes.view_labels_pgm_triplo ? <></> :
							<td>
								<div
									style={{
										display: 'flex',
										justifyContent: 'space-between',
									}}>
									<text>
										{symbolPriceFormatter(item.valor_desconto)}
									</text>
									<text>
										{item.valor_desconto === 0
											? '0,00'
											: Number(
												(item.valor_desconto /
													item.valor_bruto) *
												100
											).toLocaleString('pt-BR', {
												minimumFractionDigits: 2,
												maximumFractionDigits: 2,
											})}
										%
									</text>
								</div>
							</td>
						}
						<td>
							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
								}}>
								{symbolPriceFormatter(item.valor_liquido)}
							</div>
						</td>
						{projetos.includes(user.dados.tipo_projeto) &&
							<td>
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
									}}>
									{retornaTipoCupom(item.tipo_cupom)}
								</div>
							</td>
						}
						<td>
							<div
								style={{
									display: 'flex',
									justifyContent: 'center',
								}}>
								{item.status ? <StatusVenda status={item.status} /> : '-'}
							</div>
						</td>
					</tr>
				))}
			</tbody>
		</Table>
	);
}

export function CardSplit({ dadosSplit, loadingRecebimentos, recebimentos, user }) {
	const [nameParticipante, setNameParticipante] = useState('Mostrar Participante');
	const cardSplit = [
		{
			nome: 'Total Bruto',
			nome_index: 'total_bruto',
			color: 'white',
			bg_color: color.softBlack,
		},
		{
			nome: 'Débito',
			nome_index: 'total_debito',
			color: 'gray',
			bg_color: color.yellow,
		},
		{
			nome: 'Crédito à vista',
			nome_index: 'total_credito',
			color: 'gray',
			bg_color: color.yellow,
		},
		{
			nome: 'Crédito Parcelado',
			nome_index: 'total_parcelado',
			color: 'gray',
			bg_color: color.yellow,
		},
		{
			nome: 'Descontos',
			nome_index: 'total_desconto',
			color: 'red',
			bg_color: color.white,
		},
		{
			nome: 'Ajustes',
			nome_index: 'total_ajuste',
			color: 'gray',
			bg_color: color.white,
		},
		{
			nome: 'Recebimentos',
			nome_index: 'total_liquido',
			color: 'white',
			bg_color: color.softBlack,
		},
		// {
		// 	nome: 'Valor Cedido',
		// 	nome_index: 'total_cedido',
		// 	color: 'gray',
		// 	bg_color: color.white
		// }
	];

	if (dadosSplit.parent && !user.dados.permissoes.view_labels_pgm_triplo) {
		cardSplit.push({
			nome: 'Plano Split',
			nome_index: 'split_porcentual',
			color: 'white',
			bg_color: color.blue,
		});
	}

	function showName() {
		nameParticipante === 'Mostrar Participante' &&
			dadosSplit.nome_lojista_pai
			? setNameParticipante(dadosSplit.nome_lojista_pai)
			: setNameParticipante('Mostrar Participante');
	}

	return (
		<Row className="mt-5">
			{cardSplit.map((item, index) => (
				<Col key={`${item.nome}-${index}`}>
					<Text style={{textAlign: 'center'}} className="notranslate">{item.nome}</Text>
					<Card
						style={{
							backgroundColor: item.bg_color,
							borderRadius: '0 10px 10px 10px',
						}}>
						<CardBody className="py-4 px-2">
							{loadingRecebimentos ? (
								<div className="d-flex justify-content-center">
									<LoaderMini />
								</div>
							) : item.nome_index === 'total_desconto' ? (
								<Text color={item.color} size="big" center>
									{recebimentos.dados[item.nome_index] ? `- ${symbolPriceFormatter(
										recebimentos.dados[item.nome_index]
									)} `: 'R$ 0,00'}
								</Text>
							) : (
								<div>
									{item.nome_index === 'split_porcentual' ||
										item.nome_index === 'split_recebiveis' ? (
										dadosSplit.parent ? (
											<>
												<div
													style={{
														display: 'flex',
														flexDirection: 'row',
														marginTop: -20,
														color: 'white',
													}}>
													<Text
														color={item.color}
														size="small"
														center>
														Recebe:
													</Text>
												</div>
												<div
													style={{
														display: 'flex',
														flexDirection: 'row',
														justifyContent:
															'space-between',
														marginTop: -6,
														marginLeft: '15%',
														marginRight: '15%',
													}}>
													<Text
														color={item.color}
														size="big"
														center>
														{dadosSplit.em_conta ? dadosSplit.em_conta : '0'}
														%
													</Text>
													{/* {recebimentos.dados
															.recebimentos &&
															recebimentos.dados
																.recebimentos[0]
															? recebimentos.dados
																.recebimentos[0]
																.split_porcentual
															: '0'} */}
													<Text
														color={item.color}
														size="big"
														center>
														|
													</Text>
													<Text
														color={item.color}
														size="big"
														center>
														{dadosSplit.credito ? dadosSplit.credito : '0'}
														%
													</Text>
												</div>
												<div
													style={{
														display: 'flex',
														flexDirection: 'row',
														marginTop: -8,
														marginBottom: -10,
														marginLeft: '15%',
														marginRight: '15%',
														justifyContent:
															'space-between',
													}}>
													<Text
														color={item.color}
														size="small"
														center>
														na conta
													</Text>
													<Text
														color={item.color}
														size="small"
														center>
														em crédito
													</Text>
												</div>
												<div
													style={{
														display: 'flex',
														justifyContent: 'left',
														marginBottom: -20,
														marginLeft: '2%',
														marginTop: '5%',
													}}>
													{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
													<a
														style={{
															textDecoration:
																'none',
															cursor: 'pointer',
															display: 'flex',
															alignItems:
																'center',
															flexDirection:
																'row',
														}}
														role="none"
														title={nameParticipante}
														onClick={() =>
															showName()
														}>
														<img
															alt="participanteLink"
															className="mr-2"
															src={
																nameParticipante ===
																	'Mostrar Participante'
																	? ParticipanteIcon
																	: ParticipanteIconPreenchido
															}
														/>

														{nameParticipante !==
															'Mostrar Participante' &&
															nameParticipante.length >
															16 ? (
															// eslint-disable-next-line react/jsx-indent
															<Text
																color={
																	item.color
																}
																size="small"
																center>
																{`${nameParticipante.substr(
																	0,
																	16
																)}...`}
															</Text>
														) : (
															<Text
																color={
																	item.color
																}
																size="small"
																center>
																{
																	nameParticipante
																}
															</Text>
														)}
													</a>
												</div>
											</>
										) : (
											<Text
												color={item.color}
												size="big"
												center>
												{recebimentos.dados
														.total_liquido ? symbolPriceFormatter(
													recebimentos.dados
														.total_liquido
												): 'R$0,00'}
											</Text>
										)
									) : (
										<Text
											color={item.color}
											size="big"
											center>
											{recebimentos.dados[
												item.nome_index
												] ? symbolPriceFormatter(
												recebimentos.dados[
												item.nome_index
												]
											): 'R$0,00'}
										</Text>
									)}
								</div>
							)}
						</CardBody>
					</Card>
				</Col>
			))}
		</Row>
	);
}
